import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "@/components/ui/sonner";
import { api } from "@/lib/api";

const initialForm = { name: "", email: "", password: "" };

export const useAuthForm = (mode) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(initialForm);
  const navigate = useNavigate();

  const updateForm = (field, value) => setForm((current) => ({ ...current, [field]: value }));

  const submitAuth = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const payload = mode === "register" ? form : { email: form.email, password: form.password };
      await api.post(`/auth/${mode === "register" ? "register" : "login"}`, payload);
      toast.success(mode === "register" ? "Your reflection space is ready." : "Welcome back.");
      navigate("/dashboard");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return { form, loading, submitAuth, updateForm };
};